<template>
    <div class="component-container">
        <div v-if="!showTime" class="message" @click="sendSMS">
            获取短信验证码
        </div>
        <div v-else class="recapture">
            <i>{{ time }}</i>
            <em>秒后可重新获取</em>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SmsCode',
    props: {
        countDown: {
            type: Number,
            default: 60
        }

    },
    data() {
        return {
            time: 0,
            timeId: null,
            showTime: false
        };
    },
    mounted() {
        this.time = this.countDown;
    },
    methods: {
        // 不做防抖
        sendSMS(callback) {
            const next = () => {
                this.showTime = true;
                if (this.time === this.countDown) {
                    clearInterval(this.timeId);
                    this.timeId = setInterval(() => {
                        if (this.time <= 0) {
                            clearInterval(this.timeId);
                            this.showTime = false;
                            this.time = this.countDown;
                            return;
                        }
                        this.time--;
                    }, 1000);
                }
            };
            this.$emit('send', next);
        }
    }
};
</script>

<style scoped lang="scss">
.component-container {
    user-select: none;
    font-style: normal;
    line-height: 50px;
    height: 50px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC,Montserrat-Regular, Montserrat;
    font-weight: 400;
    color: #9CA6B9;
    .message {
        line-height: 50px;
        height: 50px;
        cursor: pointer;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC,Montserrat-Regular, Montserrat;
        font-weight: 400;
        color: #0056FF;

    }
    .recapture {
        line-height: 50px;
        height: 50px;
        & * {
            font-style: normal;
        }

        i {
            padding-right: 3px;
        }

        em {
            cursor: wait;
        }
    }
}
</style>
